import { Navigate, Route, Routes } from "react-router-dom";

import PreventiveMaintenance from "./preventiveMaintenance";
import FleetManagerAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import BudgetsV2Page from "./budgets";
import { FeatureFlag } from "../../components/FeatureFlag";
import SupportPage from "../../components/support";
import SupportDetailsPage from "../../components/support/pages/details";
import NewSupportCallPage from "../../components/support/newSupportCall";

const FleetManagerRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/fleet-manager/preventive-maintenance" />} />
    <Route path="/preventive-maintenance" element={<PreventiveMaintenance {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route path="/appointments/*" index element={<FleetManagerAppointmentsRoutes {...props} />} />
    <Route path="/budgets/*" element={<FeatureFlag name="budget.manager"><BudgetsV2Page {...props} /></FeatureFlag>} />
    <Route path="/budgets-kanban/*" element={<FeatureFlag name="budget.manager"><BudgetsV2Page {...props} /></FeatureFlag>} />
    <Route path="/support" element={<SupportPage {...props} />} />
    <Route path="/support/new-support-call" element={<NewSupportCallPage {...props} />} />
    <Route path="/support/details" element={<SupportDetailsPage {...props} />} />
  </Routes>
);

export default FleetManagerRoutes;
